module.exports = __webpack_public_path__ + "static/media/reverseSort.44dd0e34.svg";